/* unplugin-vue-components disabled */import { render } from "./AdvancedBarChart.vue?vue&type=template&id=987f1cae&scoped=true&ts=true"
import script from "./AdvancedBarChart.vue?vue&type=script&lang=ts"
export * from "./AdvancedBarChart.vue?vue&type=script&lang=ts"

import "./AdvancedBarChart.vue?vue&type=style&index=0&id=987f1cae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-987f1cae"]])

export default __exports__